import { CARREGAR_INFORMACOES_SERVER, EDITAR_INFORMACOES } from "../constants/constants";
import {database} from '../firebase'
import {editarInformacoes} from '../actions/informacoes'

export default ({dispatch}) => next => action =>{
    
        if(action.type == CARREGAR_INFORMACOES_SERVER){
            console.log(':::::::::::::::::::::::::::', action)
            database.ref('/informacoes/').on('value', (snap)=>{
                console.log(snap.val(), '|||||||||||||||||||||||||||||||||||||||||||||||||||||||||')
                dispatch(editarInformacoes(
                    snap.val().nome,
                    snap.val().telefones,
                    snap.val().endereco
                ));
            })
        }

        if(action.type == EDITAR_INFORMACOES){
            let updates = {}
            let {nome, telefones, endereco} = action
            updates['/informacoes/'] = {nome, telefones, endereco}
            database.ref().update(updates);
            next(action)
        }
           
    next(action);
}



// WEBPACK FOOTER //
// ./src/middlewares/carregarInformacoes.js